import TheGrid from '@/views/isolated/submitted/grid'
import Edit from '@/views/isolated/submitted/edit'

export default {
  path: '/isolated/submitted',
  redirect: '/isolated/submitted/index',
  name: 'submitted',
  meta: {
    auth: {
      redirect: {
        name: 'submitted.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Equipas'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'submitted.index',
    component: TheGrid,
    meta: {
      auth: true,
      roles: ['SUPER','UFS'],
      forbiddenRedirect: '/dashboard',
      label: 'Lista'
    }
  },{
    path: 'create',
    name: 'submitted.create',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER','UFS'],
      forbiddenRedirect: '/dashboard',
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'submitted.edit',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER','UFS'],
      forbiddenRedirect: '/dashboard',
      label: 'Editar'
    }
  }]
}
